import { Dispatch, SetStateAction } from "react";

export interface IPersonalInfoStepValues {
  email: string;
  password: string;
}

export interface IEmailValidationProps {
  setEmailError: Dispatch<SetStateAction<string>>;
}

export const ERROR_MESSAGES = {
  EMAIL_EXIST: 'An account with the given email already exists.',
  USER_IS_NOT_CONFIRMED: 'User is not confirmed.'
}

export interface IEnterConfirmCodeWarning {
  nextStepHandler(): void
}